import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * Show success message in snackbar
   * @param message Message to display
   */
  showSuccess(message: string) {
    this.snackBar.open(message, '✕', {
      duration: 5000,
      panelClass: ['snackbar-success'],
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  /**
   * Show error message in snackbar
   * @param message Message to display
   */
  showError(message: string) {
    this.snackBar.open(message, '✕', {
      duration: 5000,
      panelClass: ['snackbar-error'],
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
} 